const content = {
    nav: {
        logo: 'علي شعبان',
        links: [
            // { text: 'الأعمال', to: 'project' },
            { text: 'تواصل', to: 'contact' },
        ],
    },

    header: {
        text: ['مرحباً!', 'أنا علي شعبان.', 'أنا '],
        typical: [
            'مطور برمجيات Full Stack 💻',
            2000,
            'مطور تطبيقات ويب وموبايل 📱',
            2000,
        ],
        btnText: 'اكتشف المزيد',
    },

    stack: {
        title: 'التقنيات التي أستخدمها',
        tech: [
            { img: process.env.PUBLIC_URL + '/assets/flutter.png', alt: 'Flutter' },
            { img: process.env.PUBLIC_URL + '/assets/ionic.png', alt: 'Ionic' },
            { img: process.env.PUBLIC_URL + '/assets/angular.png', alt: 'Angular' },
            { img: process.env.PUBLIC_URL + '/assets/spring.png', alt: 'Spring Boot' },
            { img: process.env.PUBLIC_URL + '/assets/vue.png', alt: 'Vue.js' },
            { img: process.env.PUBLIC_URL + '/assets/nuxt.png', alt: 'Nuxt.js' },
            { img: process.env.PUBLIC_URL + '/assets/node.png', alt: 'Node.js' },
            { img: process.env.PUBLIC_URL + '/assets/express.png', alt: 'Express.js' },
        ],
        desc: `
أختص في تطوير تطبيقات الموبايل والويب متعددة المنصات.

في تطبيقات الموبايل، أستخدم بشكل أساسي Flutter و Ionic لبناء تطبيقات عالية الجودة
وعالية الأداء لأنظمة Android و iOS بالإضافة إلى تطبيقات PWA.

في الويب والـ Backend، أعمل غالباً باستخدام Angular و Node.js (Express)،
بالإضافة إلى Java Spring Boot لبناء خدمات Backend قابلة للتوسع وسهلة الصيانة.

أركز على البنية النظيفة، الأداء، والحلول الجاهزة للإنتاج،
وأحرص دائماً على تطوير مهاراتي من خلال استكشاف أحدث الأدوات والتقنيات.
        `,
    },

    languages: {
        title: 'اللغات',
        list: [
            { name: 'العربية', level: 'اللغة الأم', percent: 100 },
            { name: 'الإنجليزية', level: 'متقدم', percent: 90 },
            { name: 'الفرنسية', level: 'متقدم', percent: 80 },
            { name: 'الإيطالية', level: 'استخدام عملي في العمل', percent: 30 },
            { name: 'التركية', level: 'متوسط', percent: 40 },
        ],
    },

    project: {
        visible: false,
        title: 'المشاريع',
        img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
        imgPlaceholder: 'data:image/png;base64,...',
        projectName: 'Meetup',
        desc: 'البدء بتطبيق Meetup (أول مشروع لي باستخدام React)',
        website: 'https://meetups-project-86e41.web.app/',
    },

    contact: {
        title: 'تواصل معي',
        desc: `
مطور برمجيات Full Stack بخبرة تزيد عن 5 سنوات في تطوير تطبيقات الويب
وتطبيقات الموبايل متعددة المنصات.

لدي خبرة عملية قوية في Flutter و Ionic و Angular و Node.js و Java Spring Boot،
وعملت على تطبيقات مؤسسية وتجارية جاهزة للإنتاج
لعملاء دوليين.

أركز على بناء حلول برمجية قابلة للتوسع ونظيفة وسهلة الصيانة،
وأتأقلم بسرعة مع بيئات Agile وأعمل بفعالية ضمن فرق العمل.
        `,
        socials: [
            {
                alt: 'whatsapp',
                img: process.env.PUBLIC_URL + '/assets/whatsapp.png',
                link: 'https://api.whatsapp.com/send/?phone=905421959236&text&type=phone_number&app_absent=0',
            },
            {
                alt: 'email',
                img: process.env.PUBLIC_URL + '/assets/gmail.png',
                link: 'mailto:alichaabane.work@gmail.com',
            },
            {
                alt: 'linkedin',
                img: process.env.PUBLIC_URL + '/assets/link.png',
                link: 'https://www.linkedin.com/in/ali-chaabane/',
            },
            {
                alt: 'github',
                img: process.env.PUBLIC_URL + '/assets/github.png',
                link: 'https://github.com/alichaabane',
            },
        ],
        img: process.env.PUBLIC_URL + '/assets/my-image.jpg',
    },
};

export default content;
